import { Element, useNode } from "@craftjs/core";
import * as React from "react";
import { Actions } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Button from "@/components/editor/primitives/button/button-component";
import RichText from "@/components/editor/primitives/rich-text";
import BackgroundSquiggle from "@/components/editor/shared/background-squiggle";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import { PaddingWrapper } from "@/components/editor/themes/crosby/constants";
import useViewportContext from "@/hooks/use-viewport-context";

import { Wrapper } from "./about-details-component-styles";
import {
  DEFAULT_ABOUT_DETAILS_CTA_TEXT,
  DEFAULT_ABOUT_DETAILS_DESCRIPTION,
  DEFAULT_ABOUT_DETAILS_LIST_ITEM_1,
  DEFAULT_ABOUT_DETAILS_LIST_ITEM_2,
  DEFAULT_ABOUT_DETAILS_LIST_ITEM_3,
  DEFAULT_ABOUT_DETAILS_LIST_ITEM_4,
  DEFAULT_ABOUT_DETAILS_SUBTITLE,
} from "./constants";

export default function AboutDetails() {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  const { viewport } = useViewportContext();
  const isMobile = viewport === "mobile";

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <Wrapper>
            <BackgroundSquiggle />
            <div className="z-index-lowest">
              <Element
                id="subtitle"
                is={RichText}
                text={`<h3>${DEFAULT_ABOUT_DETAILS_SUBTITLE}</h3>`}
              />
              {!isMobile && (
                <Element
                  id="cta-text"
                  is={Button}
                  data-testid="about-details-cta"
                  text={DEFAULT_ABOUT_DETAILS_CTA_TEXT}
                  action={{
                    kind: Actions.TicketSelector,
                  }}
                />
              )}
            </div>
            <Element
              id="description"
              is={RichText}
              text={`
                <p>${DEFAULT_ABOUT_DETAILS_DESCRIPTION}</p>
                <ul>
                  <li>${DEFAULT_ABOUT_DETAILS_LIST_ITEM_1}</li>
                  <li>${DEFAULT_ABOUT_DETAILS_LIST_ITEM_2}</li>
                  <li>${DEFAULT_ABOUT_DETAILS_LIST_ITEM_3}</li>
                  <li>${DEFAULT_ABOUT_DETAILS_LIST_ITEM_4}</li>
                </ul>
              `}
            />
            {isMobile && (
              <Element
                id="cta-text"
                is={Button}
                data-testid="about-details-cta"
                text={DEFAULT_ABOUT_DETAILS_CTA_TEXT}
                action={{
                  kind: Actions.TicketSelector,
                }}
              />
            )}
          </Wrapper>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

AboutDetails.craft = {
  custom: {
    displayName: "About Details",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
